import { SerializableObject } from './serializable-object';


export class RegisterViewModel extends SerializableObject {
  public organization: string;
  public inviteId: string;
  public language: string;
  public fullName: string;
  public userName: string;
  public password: string;
  public confirmPassword: string;
}
